export default __webpack_public_path__ + "177b82cdf603287fdd196cced9035681.woff2";